module.exports = __webpack_public_path__ + "img/201805-3.e28a506b.jpeg";